import { render, staticRenderFns } from "./PagePhoneButton.vue?vue&type=template&id=769f8612&"
import script from "./PagePhoneButton.vue?vue&type=script&lang=js&"
export * from "./PagePhoneButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports